module.exports = __webpack_public_path__ + "media/images/photo/plans/common/img_styling-photo-c313bee00912761dd91b1a8efa4eb684.jpg";